import { Exterior } from './exterior'
import { Glass } from './glass'
import { Interior } from './interior'
// import { WarningLights, FrameStructural } from './mechanical'
import { Tires } from './tires'

// map with question group id
export default {
  exterior: Exterior,
  interior: Interior,
  glass: Glass,
  tires: Tires,
  brakes: null,
  odors: null
  //   warningLights: WarningLights, Not Currently in use
  //   framestructural: FrameStructural,Not Currently in use
}
